// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3slfV","productName":"Table_productName__2_cF0"};